import { ExportColumn } from '../types';
import { resolveNormalizedColumnType } from './resolveNormalizedColumnType';

const NUMERIC_EXPORT_TYPES = [
  'integer',
  'float',
  'number',
  'numeric',
  'decimal',
  'double',
];

export const isNumberExportColumn = (column: ExportColumn): boolean =>
  NUMERIC_EXPORT_TYPES.includes(resolveNormalizedColumnType(column));
